var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26935 6.02521C6.0944 4.03292 9.3197 2.74523 10.9195 2.11352C15.5123 0.315607 16.467 -0.000244141 17.0862 -0.000244141C17.2152 -0.000244141 17.5249 0.0240522 17.7313 0.169829C17.8861 0.29131 17.9377 0.461383 17.9635 0.582864C17.9893 0.704345 18.0151 0.971603 17.9893 1.19027C17.7313 3.64418 16.6734 9.64534 16.1057 12.3908C15.8735 13.557 15.4091 13.9458 14.9704 13.9944C14.0157 14.0673 13.2675 13.387 12.3386 12.8281C10.8937 11.9292 10.068 11.3704 8.64884 10.4957C7.02329 9.47527 8.08119 8.91646 9.01007 8.0175C9.24229 7.77454 13.4997 4.1544 13.5771 3.81426C13.5771 3.76567 13.6029 3.61989 13.4997 3.547C13.3965 3.47411 13.2675 3.49841 13.1643 3.5227C13.0094 3.547 10.6872 5.00477 6.17181 7.87172C5.50095 8.30905 4.90749 8.50342 4.36564 8.50342C3.77218 8.50342 2.63688 8.18757 1.7854 7.92031C0.753302 7.60446 -0.0723748 7.43439 0.00503243 6.89987C0.0824397 6.60832 0.495278 6.31677 1.26935 6.02521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/social_1.4ef274756d6ba50c54ae740534985cf3.svg";
export { ForwardRef as ReactComponent };